import styled from 'foundations-theming/utils';
const LoadingPropertyValue = styled.div.attrs({
  'data-test-id': 'loading-property-value',
  'data-loading': true
}).withConfig({
  displayName: "LoadingPropertyValue"
})(["background-color:", ";line-height:20px;height:20px;width:100%;"], ({
  theme
}) => theme.color['fill-field-default']);
export default LoadingPropertyValue;